import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from 'src/app/shared/modules/material.module';


import { Formly2Component } from 'src/app/shared/components/formly2/formly2.component';

// import { DatePipe } from '@angular/common';

// Pipes
// import { FromPicklistPipe } from 'src/app/shared/pipes/fromPicklistPipe.pipe';
// import { ToPicklistPipe } from 'src/app/shared/pipes/toPicklistPipe.pipe';
// import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  declarations: [
    Formly2Component,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    Formly2Component,
    // DatePipe,
    // FromPicklistPipe,
    // ToPicklistPipe,
    // TableNamePipe,
  ],
  providers: [
    // DatePipe,
    // FromPicklistPipe,
    // ToPicklistPipe,
    // TableNamePipe,
  ]
})
export class SharedModule { }

